// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__V4SdX","anim":"Navigation_anim__WglzU"};